import { Injectable } from '@angular/core';
import { tap, timeout } from 'rxjs/operators';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CommonService, MAX_TIMEOUT_LIMIT } from '../common/common.service';

const MAX_WAIT_TIME = 600000;  // 10 min

@Injectable()
export class DrInterceptor implements HttpInterceptor {
    constructor(private commonService: CommonService) { }
    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(timeout(MAX_WAIT_TIME), // every call will wait at most MAX_WAIT_TIME for a response
            tap(
                event => {
                    if (event instanceof HttpResponse) {
                        this.commonService.noOfRequestsWithHttpResponseError = 0;
                        // console.log('api call success :', event);
                        // added !event.body.totalTasks extra condition to filter out listTasks results from WB otherwise WB shows empty when first task from list has status FAILURE
                        if (event.body && event.body.tasks && event.body.tasks[0] && event.body.tasks[0].taskStatus === 'FAILURE' && !event.body.totalTasks) {
                            event.body.status = 'FAILURE';
                            event.body.extendedStatus = event.body.tasks[0].extendedStatus;
                            const newResponse = event.clone({ body: event.body });

                            return newResponse;
                        }
                    }
                },
                error => {
                    if (error && error.status === 0) {
                        const isTestServerHealth = error.url && error.url.includes('testServerHealth');
                        if (isTestServerHealth) {
                            this.commonService.noOfRequestsWithHttpResponseError = MAX_TIMEOUT_LIMIT;
                        } else if (this.commonService.noOfRequestsWithHttpResponseError < MAX_TIMEOUT_LIMIT) {
                            this.commonService.noOfRequestsWithHttpResponseError++;
                        }
                    }
                }
            )
        );
    }
}
